import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './BarcodeParsing.frontend.types'

@Injectable({ providedIn: 'root' })
export class BarcodeParsing_parse_gs1_barcode_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { inputScan: string }): Promise<{ reasons?: string[], extractedValues?: { gtin?: string, serialNumber?: string, expirationDate?: string, lotNumber?: string, sscc?: string, varCount?: string } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inputScan)) {
      missingRequiredInParams.push('\'inputScan\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/BarcodeParsing/functions/parse_gs1_barcode_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

